export enum Settings {
  NpdbConfigurationSegments = 'NpdbConfigurationSegments'
}
